"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compact = void 0;
/**
 * Creates a "compact" shallow copy of `subject`-- a version where all `nullish` elements are removed.
 * @example
 * compact([0, '', false, Number.NaN, null, undefined]) // returns [0, '', false, Number.NaN]
 */
function compact(subject) {
    return subject.filter((element) => element != null);
}
exports.compact = compact;
//# sourceMappingURL=#compact.js.map